"use client";

import StyledIcon from "@litonarefin/components/StyledIcon";
import { getSourceSite } from "@litonarefin/utils/getSourceSite";
import { getIcon } from "@litonarefin/utils/icons";
import { usePathname } from "next/navigation";
import React, { useState, useEffect } from "react";

const siteSource = getSourceSite();

const TableOfContent = () => {
  const [activeContent, setActiveContent] = useState(true);
  const [headings, setHeadings] = useState([]);

  const pathname = usePathname();

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".jlt-docs-content h2")).map(
      (elem, i) => {
        if (!elem.getAttribute("id")) {
          elem.setAttribute("id", `heading_${++i}`);
        }
        return {
          id: elem.id,
          text: elem.innerText,
        };
      }
    );
    setHeadings(elements);

    //Add Body Class
    // let reload = false;
    // let timeOut;

    // const body = document.body;
    // body.classList.add("jlt-table-of-content");

    // timeOut = setTimeout(() => {
    //   reload = true;
    // }, 1);

    // Show Hide Table of Content
    const isHiddenData = localStorage.getItem(`${siteSource}_docs_t_content`);
    if (isHiddenData) {
      const isHidden = JSON.parse(isHiddenData);
      if (isHidden && activeContent) {
        setActiveContent(false);
      }
    }

    // return () => {
    //   if (reload) {
    //     clearTimeout(timeOut);
    //     body.classList.remove("jlt-table-of-content");
    //   }
    // };
  }, []);

  if (!headings?.length) return;

  return (
    <div
      className={`table-of-content jlt-sticky jlt-top-8 jlt-hidden md:jlt-flex jlt-w-[250px]`}
      style={{ transition: "all 0.4s" }}
    >
      <div className="jlt-relative jlt-flex jlt-items-center">
        {/* ${
            activeContent ? "jlt-left-[-26px]" : "jlt-left-[-68px]"
          } */}
        <button
          type="button"
          className={`jlt-flex jlt-items-center jlt-absolute jlt-left-0 jlt-top-5`}
          onClick={() => {
            setActiveContent(!activeContent);
            localStorage.removeItem(`${siteSource}_docs_t_content`);
          }}
          // style={{ transition: "all 0.3s" }}
        >
          {activeContent ? null : (
            <div className="jlt-flex jlt-items-center jlt-justify-center jlt-p-2 jlt-bg-white jlt-border jlt-rounded-md">
              <span
                className={`${activeContent ? "jlt-rotate-[180deg]" : "jlt-rotate-[0deg]"}`}
                // style={{ transition: "all 0.3s" }}
              >
                <StyledIcon styles={{ stroke: "#171717", width: "22px", height: "22px" }}>
                  {getIcon("tableOfContent")}
                </StyledIcon>
              </span>
            </div>
          )}

          {/* {!activeContent ? (
            <div className="jlt-absolute jlt-top-auto jlt-left-[-24px] !jlt-block jlt-rotate-[-90deg] jlt-origin-top-[-50%]">
              <p className="jlt-px-[12px] jlt-py-[10px] jlt-bg-gray-300 jlt-text-primary-foreground jlt-text-[14px] jlt-font-semibold jlt-rounded-t-md jlt-w-max jlt-select-none jlt-tracking-[0.5px]">
                Table Of Content
              </p>
            </div>
          ) : null} */}
        </button>

        {activeContent ? (
          <div className="jlt-relative jlt-pl-5 jlt-pr-2 jlt-border jlt-border-border jlt-bg-white  jlt-w-full jlt-shadow-md jlt-rounded-l-md jlt-py-5 jlt-z-50">
            <span
              onClick={() => {
                setActiveContent(false);
                localStorage.setItem(`${siteSource}_docs_t_content`, true);
              }}
              style={{ transition: "all 0.3s" }}
              className="jlt-bg-[#FCFDFF] jlt-border jlt-border-r-0 jlt-rounded-tl-[3px] jlt-rounded-bl-[3px] jlt-absolute -jlt-left-[25px] jlt-top-[16px] jlt-cursor-pointer jlt-p-1"
            >
              <StyledIcon
                styles={{
                  stroke: "#171717",
                  width: "16px",
                  height: "16px",
                  padding: "2px",
                  transform: "rotate(180deg)",
                }}
              >
                {getIcon("leftArrow")}
              </StyledIcon>
            </span>

            <h4 className="jlt-text-[18px] jlt-font-bold jlt-text-foreground jlt-leading-5 jlt-mb-4">
              Table of Contents
            </h4>

            <ul className="jlt-pr-3 jlt-list-[disclosure-closed] jlt-list-inside jlt-overflow-x-hidden jlt-overflow-y-auto [&::-webkit-scrollbar]:jlt-w-1 [&::-webkit-scrollbar]:jlt-bg-gray-100 [&::-webkit-scrollbar-thumb]:jlt-bg-gray-300 jlt-flex jlt-flex-col jlt-gap-2">
              {headings.map((heading, i) => (
                <li
                  key={heading.id}
                  className="jlt-pl-[15px] jlt-pr-2 jlt-text-[13px] jlt-font-medium jlt-leading-[20px] jlt-text-foreground"
                >
                  <a
                    href={`#${heading.id}`}
                    className="jlt-select-none hover:jlt-text-[var(--primary)] jlt-transition-all jlt-duration-150 hover:jlt-underline"
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(`#${heading.id}`).scrollIntoView({
                        behavior: "smooth",
                      });
                    }}
                  >
                    {heading.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ) : null}
      </div>

      {headings ? (
        <script
          type="application/ld+json"
          id="table_of_content"
          dangerouslySetInnerHTML={{
            __html: `{"@context": "https://schema.org","@type": "ItemList","name": "Table of Contents","itemListElement": ${getTableOfContentItems(
              headings,
              pathname
            )}
            }`,
          }}
        />
      ) : null}
    </div>
  );
};

function getTableOfContentItems(headings, pathname) {
  const items = headings.map((heading, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: heading.text,
    url: `${process.env.NEXT_PUBLIC_NEXTJS_SITE_URL}${pathname}#${heading.id}`,
  }));

  return JSON.stringify(items);
}

export default TableOfContent;
